import { UiFlagsStore } from "../stores/uiFlagsStore";
import { PartnerNames } from "./partner";

export class Widget {
    public static getWidgetNode() {
        const widget = document.getElementsByTagName("tuz-estate-widget");

        if (widget) {
            return widget[0]?.shadowRoot?.getElementById("tuz-estate-widget-app");
        }

        return null;
    }

    public static resize(uiFlagsStore: UiFlagsStore) {
        const widgetApp = this.getWidgetNode();
        const mobileSize = 944;
        const mobileSizeForPackages = 650;

        if (!widgetApp) {
            return;
        }

        const size = widgetApp.clientWidth;
        if (size && size <= mobileSize) {
            uiFlagsStore!.setMobileSize();
        } else {
            uiFlagsStore!.setDesktopSize();
        }

        if (size && size <= mobileSizeForPackages) {
            uiFlagsStore!.setMobileSizeForPackages();
        } else {
            uiFlagsStore!.setDesktopSizeForPackages();
        }
    }

    public static scrollToTopOfWidgetDefault() {
        const widgetApp = this.getWidgetNode();

        if (!widgetApp) {
            return;
        }

        widgetApp.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
    }

    public static scrollToTopOfWidgetInSobol() {
        // because Sobol has a large header bar that cover top of Widget

        const headerInSobol = document.getElementsByClassName("m-subheader");

        if (!headerInSobol || !headerInSobol[0]) {
            this.scrollToTopOfWidgetDefault();
            return;
        }

        headerInSobol[0].scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
    }

    public static scrollToTopOfWidget(uiFlagsStore: UiFlagsStore) {
        if (uiFlagsStore.partnerName === PartnerNames.sobol) {
            Widget.scrollToTopOfWidgetInSobol();
        } else {
            Widget.scrollToTopOfWidgetDefault();
        }
    }

    public static goToNextStep(uiFlagsStore: UiFlagsStore) {
        uiFlagsStore.incrementStep();
        Widget.scrollToTopOfWidget(uiFlagsStore);
    }

    public static goToPrevStep(uiFlagsStore: UiFlagsStore) {
        uiFlagsStore.decrementStep();
        Widget.scrollToTopOfWidget(uiFlagsStore);
    }
    public static scrollToClass(className: string) {
        const node = this.getNode(className);
        if (node) {
            node.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }

    public static getNode(className: string) {
        const widgetApp = Widget.getWidgetNode();
        if (!widgetApp) {
            return null;
        }
        const node = widgetApp.getElementsByClassName(className);
        if (node && node[0]) {
            return node[0];
        }
        return null;
    }
}
